import { arrayOf, bool, exact, string } from "prop-types";
import { baseDatabaseModelType } from "./baseDatabaseModel";

/** @deprecated use TypeScript interface or type instead */
export const milestoneTemplateType = exact({
  ...baseDatabaseModelType,
  abbreviation: string,
  approvers: arrayOf(string),
  canBeAddedTo: arrayOf(string),
  canBeDeletedFrom: arrayOf(string),
  canBeSkipped: arrayOf(string),
  defaultProductCategories: arrayOf(string),
  documentsRequired: bool,
  id: string,
  name: string,
  partitionKey: string,
});
